import React from "react";
import { Id } from "../../../../convex/_generated/dataModel";

export interface Tag {
  _id: Id<"tags">;
  name: string;
}

interface TagInputProps {
  tagInput: string;
  setTagInput: (val: string) => void;
  currentTags: Tag[];
  setCurrentTags: (tags: Tag[]) => void;
  allUserTags: Tag[];
  onAddTag: () => void;
  onRemoveTag: (tagId: Id<"tags">) => void;
}

export const TagInput: React.FC<TagInputProps> = ({
  tagInput,
  setTagInput,
  currentTags,
  setCurrentTags,
  allUserTags,
  onAddTag,
  onRemoveTag,
}) => {
  return (
    <div>
      <label htmlFor="tags" className="block text-sm font-medium text-base-content">Tags</label>
      <div className="join mt-1">
        <input
          type="text"
          id="tags"
          value={tagInput}
          onChange={(e) => setTagInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); onAddTag();}}}
          placeholder="Add a tag and press Enter"
          className="input input-bordered join-item flex-grow bg-white"
        />
        <button
          type="button"
          onClick={onAddTag}
          className="btn btn-neutral join-item"
        >
          Add
        </button>
      </div>
      <div className="mt-2 flex flex-wrap gap-2">
        {currentTags.map((tag) => (
          <div
            key={tag._id}
            className="badge badge-primary gap-2"
          >
            {tag.name}
            <button
              type="button"
              onClick={() => onRemoveTag(tag._id)}
              className="btn btn-ghost btn-xs btn-circle"
            >
              ✕
            </button>
          </div>
        ))}
      </div>
      {allUserTags.length > 0 && (
        <div className="mt-2">
          <p className="text-xs text-base-content/70 mb-1">Existing tags:</p>
          <div className="flex flex-wrap gap-1">
            {allUserTags.filter(ut => !currentTags.find(ct => ct.name === ut.name)).slice(0,10).map(tag => (
              <button type="button" key={tag._id} onClick={() => { setTagInput(tag.name); }} className="btn btn-ghost btn-xs">
                {tag.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}; 